var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { combineReducers } from "redux";
import { ERevampReportReducers } from "@adapters/presenters/action-interfaces/Reports/common/CommonReportInterfaces";
import { UPDATE_DWNLD_STATE_DATA, } from "@redux/interfaces/Reports/CoreReports/IDownloadNSendEmailReportReducer";
import commonOnePlatFormReducer, { CommonOnePlatFormInitState, } from "@redux/reducers/common/commonReducer";
var initialState = {
    fromDate: new Date(),
    toDate: new Date(),
    reportType: "",
    reportName: "",
    searchParams: [],
    urlParts: "",
    email: true,
    download: true,
    pdfCheck: true,
    excelCheck: false,
    openDownloadPopup: false,
    showDownloadReportDPModal: false,
};
var DownloadNSendEmailReport = function (state, action) {
    var _a;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case UPDATE_DWNLD_STATE_DATA:
            return __assign(__assign({}, state), ((_a = action.payload) !== null && _a !== void 0 ? _a : initialState));
        default:
            return state;
    }
};
export default combineReducers({
    reducersData: DownloadNSendEmailReport,
    commonData: function (state, action) {
        if (state === void 0) { state = new CommonOnePlatFormInitState(); }
        return commonOnePlatFormReducer(state, action, ERevampReportReducers.DownloadNSendEmailReport);
    },
});
